export const SET_NOTIFICATIONS = 'SET_NOTIFICATIONS';
